export default __webpack_public_path__ + "static/media/HeimdallContructionSansFond.3985e122.png";